export const globalData = {
  peruHC: 1408,
  chileGdneHC: 510,
  chilePeopleUnderManagement: 609,
  combinedHC: 1918,
  combinedHCStatus: 'current' as const,
}
